import { trackPromise } from 'react-promise-tracker';
import { getClaimDetailsService, getClaimsService, getSelfBenefitsExplanationService,getDependentBenefitsExplanationService } from '../../services/claimsDetailsService';
import constants from './constants';

// action creators
export const setClaims = payload => ({
  type: constants.SET_CLAIMS,
  payload
});
export const setClaimsYouOwe = payload => ({
  type: constants.SET_CLAIMS_YOU_OWE,
  payload,
});

export const setClaimsError = payload => ({
  type: constants.SET_CLAIMS_ERROR,
  payload
});

export const setClaimDetailsBegin = payload => ({
  type: constants.SET_CLAIM_DETAILS_BEGIN,
  payload
});

export const setClaimDetailsSuccess = payload => ({
  type: constants.SET_CLAIM_DETAILS_SUCCESS,
  payload
});
export const setClaimsCleanUp = () => ({
  type: constants.SET_CLAIMS_CLEANUP
});

export const setClaimDetailsError = payload => ({
  type: constants.SET_CLAIM_DETAILS_ERROR,
  payload
});

export const getClaimDetails = (claimId,tenantId, memberAccountHeader) => {
  return (dispatch) => {
    dispatch(setClaimDetailsBegin());
    trackPromise(
        getClaimDetailsService(claimId,tenantId, memberAccountHeader)
            .then(res => dispatch(setClaimDetailsSuccess(res.data)))
            .catch(err => dispatch(setClaimDetailsError(err)))
    );
};
};
  

export const getClaims = (tenantId, pageNumber, pageSize,fromDate,toDate, orderByDate, memberAccountHeader)=>{
  return (dispatch)=>
   trackPromise(
    getClaimsService(tenantId, pageNumber, pageSize, fromDate, toDate, orderByDate, memberAccountHeader)
      .then(res => {
        dispatch(
          setClaims({
            ...res.data,
          })
        );
        dispatch(getClaimsDetails(tenantId,res?.data?.content, memberAccountHeader));

      })
      .catch(err => dispatch(setClaimsError(err.message)))
  );
};
export const getClaimsDetails = (tenantId, claimList, memberAccountHeader) => {
  return dispatch => {
    const results = claimList.map((element)=> getClaimDetailsService(element.claimNumber, tenantId, memberAccountHeader ));
    trackPromise(Promise.all(results).then((response)=> {
      const youMayOwe = response.map(res => res?.data?.totalYouOwe);
      dispatch(setClaimsYouOwe(youMayOwe));
    }).catch(error => dispatch(setClaimsError('Something went wrong'+ error.message))));
  };
};
export const setClaimBenefitsBegin = () => ({
  type: constants.SET_CLAIM_DETAIL_BENEFITS_BEGIN
});

export const setClaimBenefitsSuccess = data => ({
  type: constants.SET_CLAIM_DETAIL_BENEFITS_SUCCESS,
  payload: { data }
});

export const setClaimBenefitsError = error => ({
  type: constants.SET_CLAIM_DETAIL_BENEFITS_ERROR,
  payload: { error }
});

export const setClaimBenefitsClean = () => ({
  type: constants.SET_CLAIM_DETAIL_BENEFITS_CLEANUP
});

export const getSelfBenefitsExplanation = (tenantId, claimNumber) => {
  return (dispatch) => {
    dispatch(setClaimBenefitsBegin());
    trackPromise(
      getSelfBenefitsExplanationService(claimNumber,tenantId)
            .then(res => dispatch(setClaimBenefitsSuccess(res.data)))
            .catch(err => dispatch(setClaimBenefitsError(err)))
        );
    };
};

export const getDependentBenefitsExplanation = (tenantId, claimNumber,memberID) => {
  return (dispatch) => {
    dispatch(setClaimBenefitsBegin());
    trackPromise(
      getDependentBenefitsExplanationService(claimNumber,tenantId,memberID)
            .then(res => dispatch(setClaimBenefitsSuccess(res.data)))
            .catch(err => dispatch(setClaimBenefitsError(err)))
        );
    };
};

